import { render, staticRenderFns } from "./AreaGestionale.vue?vue&type=template&id=006e6741&scoped=true"
import script from "./AreaGestionale.vue?vue&type=script&lang=js"
export * from "./AreaGestionale.vue?vue&type=script&lang=js"
import style0 from "./AreaGestionale.vue?vue&type=style&index=0&id=006e6741&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006e6741",
  null
  
)

export default component.exports